import withComponentName from '../../../../decorators/withComponentName';

import './styles.css';

const CorporateSection = ({
  head, headUpercase, subHead, text, btn, btnLink,
}) => (
  <div className="Section">
    {Boolean(head) && (
      <h1 className={headUpercase ? 'Section__head uppercase' : 'Section__head'}>{head}</h1>
    )}
    {Boolean(subHead) && <h3 className="Section__sub-head">{subHead}</h3>}
    {Boolean(text) && <p className="Section__text">{text}</p>}
    {Boolean(btn) && <a className="Section__btn--learn-more" href={btnLink}>{btn}</a>}
  </div>
);

export default withComponentName(CorporateSection);
